import toolkit from '@/app/mixins/toolkit/item';
import pensions from '@/app/mixins/toolkit/pension/pension';
import PensionScheduleFixedAmount from './pension-schedule-fixed-amount/pension-schedule-fixed-amount.vue';
import PensionSchedulePensionAmount from './pension-schedule-pension-amount/pension-schedule-pension-amount.vue';
import PensionScheduleTaxComponents from './pension-schedule-tax-components/pension-schedule-tax-components.vue';
import PensionScheduleUnrestrictedNonPreserve from './pension-schedule-unrestricted-non-preserve/pension-schedule-unrestricted-non-preserve.vue';

export default {
  name: 'pension-schedule',
  mixins: [toolkit, pensions],
  components: {
    PensionScheduleFixedAmount,
    PensionSchedulePensionAmount,
    PensionScheduleTaxComponents,
    PensionScheduleUnrestrictedNonPreserve,
  },
  data: () => ({
    isPartOneValid: false,
    isFixedAmountValid: false,
    isPensionAmountValid: false,
    isUnrestrictedNonPreserveValid: false,
  }),
  computed: {
    canContinue() {
      if (this.isPartOne) {
        if (this.isFixedAmount || this.isAccumLessFixed) {
          return this.isFixedAmountValid;
        }
        return false; // Should not be a valid pension matrix screen
      }

      if (this.isTris && (this.isPartTwo || this.isPartTwoMini)) {
        if (this.isFixedAmount || this.isAccumLessFixed) {
          return this.isFixedAmountValid && this.isUnrestrictedNonPreserveValid;
        }
        return this.isPensionAmountValid && this.isUnrestrictedNonPreserveValid;
      }

      if (this.isPartTwoMini || this.isPartTwo) {
        if (this.isFixedAmount || this.isAccumLessFixed) {
          return this.isFixedAmountValid;
        }
        return this.isPensionAmountValid;
      }

      return false;
    },
  },
  methods: {
    handlePartOneValid(isValid) {
      this.isPartOneValid = isValid;
    },
    handleFixedAmountValid(isValid) {
      this.isFixedAmountValid = isValid;
    },
    handlePensionAmountValid(isValid) {
      this.isPensionAmountValid = isValid;
    },
    handleUnrestrictedNonPreserveValid(isValid) {
      this.isUnrestrictedNonPreserveValid = isValid;
    },
    handleNextStep() {
      this.$emit('nextStep');
    },
  },
};
